import React from 'react';

interface PrevArrowProps {
  width?: number;
  height?: number;
  strokeWidth?: number;
  color?: string;
}

export const PrevArrow = ({
  width = 24,
  height = 24,
  strokeWidth = 2,
  color = '#314259',
}: PrevArrowProps): JSX.Element => {
  return (
    <div>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 12L5 12"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 19L5 12L12 5"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
